export default __webpack_public_path__ + "static/media/02 Track 2.2cf3f2b0.mp3";